import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import { GET_PLACE_FARE } from './constants';
import type { IPlaceMinimalFareInfo } from '@/Interfaces/Data';
import type { BaseRequestResponse } from '@/_types/services';

type GetPlaceFareParams = {
  cityId: string;
};

const getPlaceFare = (params: GetPlaceFareParams) => {
  const { cityId } = params;

  return apiClient
    .get<BaseRequestResponse<IPlaceMinimalFareInfo[]>>(
      `/estabelecimentos/municipios/${cityId}/fares-list`,
    )
    .then(response => response.data.data)
    .catch(
      handleResponseThrowError(
        'Não foi possível carregar as tarifas dos estabelecimentos',
      ),
    );
};

type GetPlaceFareResponse = Awaited<ReturnType<typeof getPlaceFare>>;

export const useGetPlaceFares = (
  params: GetPlaceFareParams,
  options: Omit<
    UseQueryOptions<
      GetPlaceFareResponse,
      unknown,
      GetPlaceFareResponse,
      (string | GetPlaceFareParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_PLACE_FARE, params],
    queryFn: () => getPlaceFare(params),
    ...options,
  });
};
